import { Avatar } from "@mui/material";

export default function HahstagAvatar(props) {
  if (props.large) {
    return <Avatar sx={{ backgroundColor: "#00A3ED", width: 90, height: 90, fontSize: 40 }}>#</Avatar>;
  }
  return <Avatar sx={{ backgroundColor: "#00A3ED" }}>#</Avatar>;
}
